var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2051 3.065L8.32756 0.822502C7.58506 0.395002 6.42256 0.395002 5.68006 0.822502L1.76506 3.08C0.212559 4.13 0.122559 4.2875 0.122559 5.96V10.0325C0.122559 11.705 0.212559 11.87 1.79506 12.935L5.67256 15.1775C6.04756 15.395 6.52756 15.5 7.00006 15.5C7.47256 15.5 7.95256 15.395 8.32006 15.1775L12.2351 12.92C13.7876 11.87 13.8776 11.7125 13.8776 10.04V5.96C13.8776 4.2875 13.7876 4.13 12.2051 3.065ZM7.00006 10.4375C5.65756 10.4375 4.56256 9.3425 4.56256 8C4.56256 6.6575 5.65756 5.5625 7.00006 5.5625C8.34256 5.5625 9.43756 6.6575 9.43756 8C9.43756 9.3425 8.34256 10.4375 7.00006 10.4375Z",
    fill: "#B5AA9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.44fe18d8af9262757b87c7775bf9cbef.svg";
export { ForwardRef as ReactComponent };